import React from 'react'

function Deleberation() {
  return (
    <div className='messageriebox'>
        <p style={{fontSize:'30px',marginLeft:'10px',marginTop:'10px',fontWeight:'bold'}}>Délebération</p>
        <hr/> 
       
      
    </div>
  )
}

export default Deleberation